import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import validationSchema from 'src/utils/validationSchema';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';
import { Form, Field } from 'src/components/hook-form';

import { useChannelContext } from '../hooks';
import { useConnectWhatsApp } from '../hooks/useConnectWhatsApp';

export function Step2() {
  const {
    onChangeStep,
    state: channelState,
    handleChannelName,
    handleFaceBookDeteail,
  } = useChannelContext();

  const { t } = useTranslate('translation');

  type CampaignField = { channelName: string };

  const fldList = [{ name: 'channelName', required: true }];

  const CampaignSchema = validationSchema(fldList, t);

  const defaultValues: CampaignField = {
    channelName: '',
  };

  const methods = useForm<CampaignField>({
    mode: 'all',
    resolver: zodResolver(CampaignSchema),
    defaultValues,
    values: { channelName: channelState.channelName },
  });

  const { reset, handleSubmit, watch } = methods;

  const channelName = watch('channelName');

  const onSubmit = handleSubmit(async (data) => {
    handleChannelName(data.channelName);
    reset();
  });

  const { connect, isWhatsappConnectSuccess } = useConnectWhatsApp({
    onSuccess: handleFaceBookDeteail,
  });

  return (
    <Form methods={methods} onSubmit={onSubmit} style={{ height: '100%' }}>
      <Box sx={{ height: '90%', display: 'flex', flexDirection: 'column' }}>
        <Box>
          <Grid container spacing={3} justifyContent="space-between">
            <Field.Text
              name="channelName"
              label={t('CHANNEL_NAME')}
              slotProps={{ inputLabel: { shrink: true } }}
              placeholder={t('CHANNEL_NAME')}
            />

            <Box sx={{ my: 2, width: '100%', display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button
                variant="contained"
                sx={{ background: '#50a28a', my: 2 }}
                onClick={connect}
                disabled={!channelName}
              >
                {t('SIGN_IN_WITH')} {t('FACEBOOK')}
              </Button>

              {isWhatsappConnectSuccess && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.2 }}>
                  <Iconify icon="eva:checkmark-fill" sx={{ color: 'primary.main' }} />
                  <Typography sx={{ color: '#50a28a' }}>{t('ACCOUNT_VERIFIED')}</Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button variant="outlined" color="inherit" onClick={() => onChangeStep('back')}>
              {t('PREVIOUS')}
            </Button>
          </Box>
          <Box>
            <Button
              disabled={!channelName || !isWhatsappConnectSuccess}
              // disabled={!channelName}
              size="small"
              variant="contained"
              type="submit"
              onClick={() => onChangeStep('next')}
            >
              {t('NEXT')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  );
}

// export type CampaignField = zod.infer<typeof CampaignSchema>;

// export const CampaignSchema = zod.object({
//   name: zod.string().min(1, { message: 'Channel name is required!' }),
// });
